<template>
  <multiselect-search
    v-model="valueModel"
    :open-prefetch="true"
    :allow-empty="true"
    :disabled="disabled"
    :search-url="getSearchUrl"
    :search-options="searchOptions"
    :close-on-select="true"
    :multiple="multiple"
    class="w-100"
    :skip-external-serching="skipExternalSerching"
  >
    <template #no-more-infinite>
      {{ $t("dashboard.team_search_no_more", "No more groups") }}
    </template>
  </multiselect-search>
</template>

<script>
import MultiselectSearch from "@/components/multiselect-search.vue";
import urls from "@/constants/urls";
import { defineComponent } from "vue";

export default defineComponent({
  name: "OrgExternalDonorGroupMultiselect",
  components: {
    MultiselectSearch,
  },
  props: {
    value: {
      type: [Object, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    skipExternalSerching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: null,
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.value !== null ? this.value : this.localValue;
      },
      set(val) {
        this.localValue = val;
        this.$emit("input", val);
      },
    },
    orgCustomerID() {
      return localStorage.getItem("orgId");
    },
    getSearchUrl() {
      return urls.orgExternalDonorGroups(this.orgCustomerID);
    },
    searchOptions() {
      return {
        placeholder: this.$t("dashboard.select_team", "Select external donor group"),
        changeParams: ({ page, per_page: pp, query }) => {
          return {
            query,
            page: page,
            per_page: pp,
          };
        },
        customLabel: (e) => `[${e.id}] ${e.name}`,
      };
    },
  },
});
</script>
